// 3rd party
import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';

// Components
import { ConfiguredQuicklinksV2, CustomQuicklinkV2 } from 'components/quicklinks';

// Hooks
import { useStores } from 'hooks';

// Models
import { LinkAnalyticsMicroMessageContent } from 'models/analytics';

// Utils
import {
  analyticsEvent,
  getLinkAnalyticsMicroMessage,
  getProductAnalyticsMicroMessage,
  getProgramAnalyticsMicroMessage,
  getUserAnalyticsMicroMessage,
} from '../../util/analytics';

const QuicklinksV2 = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function QuicklinksV2(): JSX.Element {
    const { analytics, productsV2, pzStore, quicklinks, user, userAuth } = useStores();

    const { activeProduct } = productsV2;
    const { pzPublisher } = pzStore;
    const { activeProgram } = user;
    const { currentUserDetails } = userAuth;

    const analyticsTrackEvents = useCallback(
      // tslint:disable-next-line:no-shadowed-variable
      function analyticsTrackEvents(rfrr: string, link?: LinkAnalyticsMicroMessageContent) {
        const microMessages = [
          getProgramAnalyticsMicroMessage(activeProgram, activeProgram?.programStatus),
          getProductAnalyticsMicroMessage(activeProduct),
        ];
        const microMessagesWithLink = [...microMessages, getLinkAnalyticsMicroMessage(link)];

        const filterAnalyticsTrackEvent = {
          'affhub.product_config': () => {
            analyticsEvent(analytics, userAuth, pzStore, rfrr, 'AffHub Product Config Presented', microMessages);
          },
          'affhub_copy_code.selected': () => {
            analyticsEvent(analytics, userAuth, pzStore, rfrr, 'AffHub Copy Code Selected', microMessagesWithLink);
          },
          'affhub_copy_link.selected': () => {
            analyticsEvent(analytics, userAuth, pzStore, rfrr, 'AffHub Copy Link Selected', microMessagesWithLink);
          },
        };

        filterAnalyticsTrackEvent[rfrr]();
      },
      [analytics, activeProgram, activeProduct, currentUserDetails, pzPublisher],
    );

    useEffect(
      function onMount() {
        setTimeout(() => {
          // TODO: Logging tracking attributes after a time delay as the values are null
          analyticsTrackEvents('affhub.product_config');
        }, 3500);

        return function onUnmount() {
          quicklinks.resetCustomQuicklink();
          quicklinks.resetConfiguredQuicklinks();
        };
      },
      [analyticsTrackEvents, quicklinks],
    );

    return (
      <article>
        <CustomQuicklinkV2 />
        <ConfiguredQuicklinksV2 />
      </article>
    );
  },
);

export default QuicklinksV2;
export { QuicklinksV2 };
